export const FILTERS = {
    businessOwnersPolicies: 'Business owners policies',
    workersCompensation: 'Workers compensation',
    riskInsurance: 'Builders risk insurance',
    autoInsurance: 'Commercial auto insurance'
}